import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Roboto', sans-serif;
    background-color: #f5f5f5;
    color: #333;
    line-height: 1.4;
    overflow: hidden; /* Prevent scrolling */
  }

  html, body, #root, .App {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
  }
  
  .App {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  button {
    cursor: pointer;
    border: none;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 16px;
    font-weight: 600;
    background-color: #4a90e2;
    color: white;
    transition: all 0.2s ease;

    &:hover {
      background-color: #3a7bc8;
    }

    &:disabled {
      background-color: #cccccc;
      cursor: not-allowed;
    }
  }

  h1, h2, h3 {
    margin-bottom: 15px;
    text-align: center;
  }
  
  /* Responsive font sizes */
  @media (max-height: 700px) {
    body {
      font-size: 14px;
    }
    
    button {
      padding: 8px 14px;
      font-size: 14px;
    }
    
    h1 {
      font-size: 1.6em;
    }
  }
  
  @media (max-height: 600px) {
    body {
      font-size: 12px;
    }
    
    button {
      padding: 6px 12px;
      font-size: 12px;
    }
    
    h1 {
      font-size: 1.4em;
    }
  }
`;

export default GlobalStyles;
